import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchVouchersNoShopAll,
  SearchVouchersNoShopAllVariables
} from "./types/SearchVouchersNoShopAll";

export const searchVouchersNoShopAll = gql`
  ${pageInfoFragment}
  query SearchVouchersNoShopAll($after: String, $first: Int!, $query: String!) {
    search: vouchersByLanguageNoShopAll(
      after: $after
      first: $first
      filter: { search: $query }
    ) {
      edges {
        node {
          id
          name
          code
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export default makeTopLevelSearch<
  SearchVouchersNoShopAll,
  SearchVouchersNoShopAllVariables
>(searchVouchersNoShopAll);
